export default "__VITE_ASSET__BsUC0Oq8__";